import { render, staticRenderFns } from "./UniLogin.vue?vue&type=template&id=173d9ee0&scoped=true&"
import script from "./UniLogin.vue?vue&type=script&lang=js&"
export * from "./UniLogin.vue?vue&type=script&lang=js&"
import style0 from "./UniLogin.vue?vue&type=style&index=0&id=173d9ee0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173d9ee0",
  null
  
)

export default component.exports